import { useEffect } from 'react';
import useIsSwiftEnabledForTrade from 'src/hooks/signedMsgOrders/useIsSwiftEnabledForTrade';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { UIMarket, UIOrderType } from '@velocity-exchange/common';

export const useSyncIsSwiftEnabled = (
	selectedMarket: UIMarket | null,
	currentOrderType: UIOrderType,
	isPostOnly: boolean
) => {
	const setState = useDriftStore((s) => s.set);

	const isSwiftEnabledForTrade = useIsSwiftEnabledForTrade({
		marketOracle: selectedMarket?.market.oracleSource,
		orderType: currentOrderType,
		postOnly: isPostOnly,
		marketIndex: selectedMarket?.marketIndex ?? 0,
	});

	useEffect(() => {
		setState((s) => {
			s.tradeForm.isSwiftEnabled = isSwiftEnabledForTrade;
		});
	}, [isSwiftEnabledForTrade]);
};
